import dayjs from 'dayjs';
import { filter } from 'lodash';
import { truncateText } from '../../utils/general.js';

const mapSectionChipLabel = ({ displayName }) => {
  switch (displayName.toUpperCase()) {
    case 'UNITED STATES':
      return 'USA';
    default:
      return displayName;
  }
};

export const getLabelForChip = ({ headerName, options, isRadio }) => {
  const numOfSectionItems = options?.length;
  const sectionCheckedItems = filter(options, { isChecked: true });
  const numOfSectionCheckedItems = sectionCheckedItems?.length;

  const isAllIntermediate =
    numOfSectionItems > numOfSectionCheckedItems && numOfSectionCheckedItems > 0;
  const isAllSectionItemsChecked =
    !isAllIntermediate && numOfSectionItems === numOfSectionCheckedItems;

  if (isAllSectionItemsChecked || (isRadio && numOfSectionCheckedItems === 0)) {
    return 'ALL';
  }
  if (numOfSectionCheckedItems === 1) {
    const MAX_CHAR = 22;
    const displayName = sectionCheckedItems[0]?.displayName;
    const sectionChipLabel = displayName ? mapSectionChipLabel({ displayName }) : '';
    const maxLength = MAX_CHAR - headerName.length;
    return truncateText({ text: sectionChipLabel, maxLength }).toUpperCase();
  }
  return numOfSectionCheckedItems;
};

export const sortAsc = (arr) =>
  arr.sort((a, b) => {
    const optionA = a.displayName.toLowerCase();
    const optionB = b.displayName.toLowerCase();

    if (optionA < optionB) {
      return -1;
    }
    if (optionA > optionB) {
      return 1;
    }
    return 0;
  });

export const shiftFEAccessory = (accessories) => {
  if (accessories.length > 0) {
    const [FE] = accessories.splice(
      accessories.findIndex((item) => item.value === 'FE'),
      1,
    );
    accessories.unshift(FE);
  }
};

export const formatDisplayName = (inputString) =>
  inputString
    ? inputString.toLowerCase().replace(/\b(?:tms|hq|[a-zA-Z])\w*\b/g, (match) =>
        // Capitalize 'tms' and 'hq', and capitalize other words
        match === 'tms' || match === 'hq'
          ? match.toUpperCase()
          : match.charAt(0).toUpperCase() + match.slice(1),
      )
    : '';

export const MIN_DATE = dayjs('2001-01');
const MIN_BUSINESS_SALES_MONTH = MIN_DATE.format('YYYYMM');

export const hasInvalidMonthRange = (cascadingFiltersLocal) => {
  const isMonthRangeSelected = cascadingFiltersLocal?.some(
    (f) => f.field === 'timePeriod' && f.value === 'Month Range' && f.isChecked,
  );
  if (!isMonthRangeSelected) {
    return false;
  }

  const businessSalesMonthEntry = cascadingFiltersLocal?.find(
    (f) => f.field === 'businessSalesMonth',
  );
  if (!businessSalesMonthEntry?.value) {
    return true;
  }

  const months = Array.isArray(businessSalesMonthEntry.value)
    ? businessSalesMonthEntry.value
    : [businessSalesMonthEntry.value];
  if (months.length === 0 || months.some((m) => !m)) {
    return true;
  }

  if (months.some((m) => m < MIN_BUSINESS_SALES_MONTH)) {
    return true;
  }

  if (months.length === 2 && months[0] && months[1]) {
    const start = dayjs(months[0], 'YYYYMM');
    const end = dayjs(months[1], 'YYYYMM');
    if (start.isAfter(end)) {
      return true;
    }
  }

  return false;
};
